module.exports = __webpack_public_path__ + "europa-50_watermark.jpg?f992d9461672ceaab8d08c60a36a7a79";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50_watermark.jpg
// module id = 384
// module chunks = 0